import { Button, Paper, Stack } from '@mui/material';
import GlobalDatagrid from '../../../../components/mui/DataGrid/GlobalDatagrid';
import FilterSection from '../TopCardOverview/FilterSection';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { typeOfStudent } from '../../../../utils/constants/GlobalStaticData';
import dayjs from 'dayjs';
import { useDispatch } from 'react-redux';
import { getRefundRoleWiseTable } from '../../../../redux/features/refundSlice';
import { useSelector } from 'react-redux';
import GlobalTable from '../../../../components/CustomTableWithPagination/GlobalTable';
import { downloadCSV, makeCSV } from '../../../../components/CustomTableWithPagination/csvExport';

export default function RoleWiseRequest() {
  const tableHead = [
    {
      field: 'role',
      headerName: 'Role',
      flex: 1,
      headerAlign: 'left',
      align: 'left',
    },
    {
      field: 'name',
      headerName: 'Name',
      flex: 1,
      headerAlign: 'left',
      align: 'left',
    },
    {
      field: 'total_refund_request_count',
      headerName: 'Total Refund Req Count',
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      // Pass-through so GlobalTable shows 0 as 0 (its default treats falsy as '—'); null/undefined still show '—'
      valueGetter: ({ value }) => value,
    },
    {
      field: 'expense_amount',
      headerName: 'Total Refund Req Amount',
      flex: 1,
      headerAlign: 'center',
      align: 'center',
    },
  ];

  const [showFilters, setShowFilters] = useState(true);
  const [selectedType, setSelectedType] = useState(typeOfStudent[0]);
  const [fromDate, setFromDate] = useState(dayjs().startOf('month').format('YYYY-MM-DD')); //DEFAULT SET TO CURRENT MONTH STARTING DATE TO ENDING DATE
  const [toDate, setToDate] = useState(dayjs().endOf('month').format('YYYY-MM-DD'));
  const [selectedRole, setSelectedRole] = useState({ id: null, value: null });
  const [selectedFinanceStatus, setSelectedFinanceStatus] = useState({ id: -1, value: 'All' });
  const [tableState, setTableState] = useState({
    page: 1,
    pageSize: 50,
    search: '',
    checkedRowIds: [],
    frozenColumns: [],
    hiddenColumns: [],
  });

  const { data, refundRoleWiseLoading, meta } = useSelector((state) => state.refund?.refundRoleWiseTable);

  const dispatch = useDispatch();
  const dispatchParams = React.useMemo(() => {
    return {
      type: selectedType?.id,
      fromDate: fromDate,
      toDate: toDate,
      role: selectedRole?.id,
      page: tableState.page,
      limit: tableState.pageSize,
      search: tableState.search,
      financeStatus: selectedFinanceStatus?.id === -1 ? '' : selectedFinanceStatus?.id,
    };
  }, [
    selectedType,
    fromDate,
    toDate,
    tableState.search,
    tableState.pageSize,
    tableState.page,
    selectedRole,
    selectedFinanceStatus,
  ]);

  useEffect(() => {
    dispatch(getRefundRoleWiseTable(dispatchParams));
  }, [tableState.search, tableState.pageSize, tableState.page]);

  const filterSubmit = React.useCallback(() => {
    dispatch(getRefundRoleWiseTable(dispatchParams));
  }, [dispatch, dispatchParams]);

  // Apply the Finance Status filter as soon as it changes (skip the initial mount; the effect above loads the table)
  const financeStatusMounted = useRef(false);
  useEffect(() => {
    if (!financeStatusMounted.current) {
      financeStatusMounted.current = true;
      return;
    }
    dispatch(getRefundRoleWiseTable(dispatchParams));
  }, [selectedFinanceStatus]);

  const handleExport = () => {
    const exportRows = [
      ...(Array.isArray(data) ? data : []),
      {
        role: 'TOTAL',
        ...PERMANENT_LAST_ROW,
      },
    ];

    const csv = makeCSV({
      headers: tableHead,
      rows: exportRows,
    });

    downloadCSV(csv, `Role_Wise_Refund_Report_${dayjs().format('YYYY-MM-DD_HH-mm')}.csv`);
  };

  const PERMANENT_LAST_ROW = useMemo(() => {
    const safeData = Array.isArray(data) ? data : [];

    return safeData.reduce(
      (acc, values) => ({
        total_refund_request_count: acc.total_refund_request_count + (Number(values?.total_refund_request_count) || 0),
        expense_amount: acc.expense_amount + (Number(values?.expense_amount) || 0),
      }),
      {
        total_refund_request_count: 0,
        expense_amount: 0,
      },
    );
  }, [data]);

  const STYLE_STRING = `tbody tr:last-child {
    font-weight : 700 ;
    background : #f7d979ff;
    }`;

  return (
    <Stack gap={1}>
      <FilterSection
        showFilters={showFilters}
        setShowFilters={setShowFilters}
        selectedType={selectedType}
        setSelectedType={setSelectedType}
        fromDate={fromDate}
        setFromDate={setFromDate}
        toDate={toDate}
        setToDate={setToDate}
        selectedRole={selectedRole}
        setSelectedRole={setSelectedRole}
        selectedFinanceStatus={selectedFinanceStatus}
        setSelectedFinanceStatus={setSelectedFinanceStatus}
        filterSubmit={filterSubmit}
        loading={false}
      />
      <Stack direction="row" justifyContent="flex-end" sx={{ mb: 2 }}>
        <Button variant="contained" onClick={handleExport} disabled={refundRoleWiseLoading || !data?.length}>
          Export
        </Button>
      </Stack>
      <Paper elevation={3}>
        {/* <GlobalDatagrid
          tableHead={tableHead}
          rowUniqueId={'userId'}
          rows={data}
          meta={meta?.totalRecords}
          loading={refundRoleWiseLoading}
        /> */}
        <GlobalTable
          tableState={tableState}
          setTableState={setTableState}
          headers={tableHead}
          rowUniqueId="userId"
          rows={data}
          meta={meta}
          loading={refundRoleWiseLoading}
          permanentLastRow={{ role: 'TOTAL', ...PERMANENT_LAST_ROW }}
          customeStyleString={STYLE_STRING}
        />
      </Paper>
    </Stack>
  );
}
